export const getVisibleSpecialties = (
  specialties: string[],
  maxVisible: number
) => {
  const visible = specialties?.slice(0, maxVisible)
  const remainingCount = Math.max(0, specialties.length - maxVisible)

  return { visible, remainingCount }
}
